export default __webpack_public_path__ + "static/media/_coldbox.2a9445eb.png";